export default "__VITE_ASSET__DVELRtkF__"